import axios from 'axios';

const getCotacoesProdutos = params => axios.get('/cotacoes/produtos/page', {
  params,
});

export default {
  getCotacoesProdutos,
};
